import React from "react";
import style from "./seeMore.module.css";
export default function SeeMore() {
  return <button className={style.button}>see more</button>;
}
